import { Beta } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { TrackingContainer } from '@mc/visibility'
import { getRankedContent } from 'libs/utils/outcomes'
import { OutcomeLink } from 'pages/outcomes/components/OutcomeLink'
import { CourseMeta, Outcome } from 'types/data'
import { useSubcategoryPageEvents } from '../../utils'
import { OutcomeTile } from '../OutcomeTile'

interface OutcomeCarouselProps {
  outcomeSlug: string
  rowIndex: number
}

export const OutcomeCarousel = ({
  outcomeSlug,
  rowIndex,
}: OutcomeCarouselProps) => {
  const { outcomeRanking, courseSlugToMeta, outcomesBySlug } = useStaticData<{
    outcomeRanking: string[]
    courseSlugToMeta: Record<string, CourseMeta>
    outcomesBySlug: Record<string, Outcome>
  }>()

  const { trackOutcomeCarouselViewed, trackOutcomeSelectionTabClicked } =
    useSubcategoryPageEvents()

  const outcome = outcomesBySlug[outcomeSlug]

  const onArrowClick = () => {
    trackOutcomeSelectionTabClicked({
      outcomeName: outcome.name,
      outcomeId: outcome.id,
    })
  }

  return (
    <TrackingContainer
      className='container mc-mb-9'
      onFirstVisible={() =>
        trackOutcomeCarouselViewed(
          outcome.name,
          rowIndex,
          outcomeRanking.length,
        )
      }
    >
      <Beta.CarouselModern
        title={
          <OutcomeLink outcomeSlug={outcome.slug}>
            <div
              id={outcome.slug}
              className='d-flex mc-mb-5'
              style={{ scrollMarginTop: '80px' }}
            >
              <p className='mc-text-h4 mc-text-color--primary mc-mr-6 mc-pt-1'>
                {rowIndex + 1}
              </p>
              <div>
                <p className='mc-text-h3'>{outcome.name}</p>
                <p className='mc-text-large mc-opacity--hinted'>
                  {outcome.oneLiner}
                </p>
              </div>
            </div>
          </OutcomeLink>
        }
        className='row'
        srLabel='outcome carousel'
        arrowCls='d-none d-sm-block'
        pagesCls='d-none d-sm-block'
        onClickNext={onArrowClick}
        onClickPrev={onArrowClick}
        noPages
      >
        {getRankedContent(outcome.contents).map((content, colIndex) => (
          <OutcomeTile
            key={content.slug}
            courseMeta={courseSlugToMeta[content.courseSlug]}
            content={content}
            isCarouselTile
            isPrioritized={rowIndex === 0 && colIndex < 3}
            outcomeName={outcome.name}
            rowIndex={rowIndex}
            rowCount={outcomeRanking.length}
            colIndex={colIndex}
            colCount={outcome.contents.length}
          />
        ))}
      </Beta.CarouselModern>
    </TrackingContainer>
  )
}
